/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Bodymap_Region_Hip_LInputs */

const en_us2_bodymap_region_hip_l = /** @type {(inputs: Bodymap_Region_Hip_LInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Left hip`)
};

const pt_br2_bodymap_region_hip_l = /** @type {(inputs: Bodymap_Region_Hip_LInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quadril esquerdo`)
};

const es_419_bodymap_region_hip_l = /** @type {(inputs: Bodymap_Region_Hip_LInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cadera izquierda`)
};

const pt_pt2_bodymap_region_hip_l = /** @type {(inputs: Bodymap_Region_Hip_LInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Anca esquerda`)
};

const fr_fr2_bodymap_region_hip_l = /** @type {(inputs: Bodymap_Region_Hip_LInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hanche gauche`)
};

const de_de2_bodymap_region_hip_l = /** @type {(inputs: Bodymap_Region_Hip_LInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Linke Hüfte`)
};

const it_it2_bodymap_region_hip_l = /** @type {(inputs: Bodymap_Region_Hip_LInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Anca sinistra`)
};

/**
* | output |
* | --- |
* | "Left hip" |
*
* @param {Bodymap_Region_Hip_LInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const bodymap_region_hip_l = /** @type {((inputs?: Bodymap_Region_Hip_LInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Bodymap_Region_Hip_LInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_bodymap_region_hip_l(inputs)
	if (locale === "es-419") return es_419_bodymap_region_hip_l(inputs)
	if (locale === "pt-PT") return pt_pt2_bodymap_region_hip_l(inputs)
	if (locale === "fr-FR") return fr_fr2_bodymap_region_hip_l(inputs)
	if (locale === "de-DE") return de_de2_bodymap_region_hip_l(inputs)
	if (locale === "it-IT") return it_it2_bodymap_region_hip_l(inputs)
	return en_us2_bodymap_region_hip_l(inputs)
});
export { bodymap_region_hip_l as "bodymap.region.hip_l" }